import React from 'react';

class NotificationPanel extends React.Component {

    render() {
        if (this.props.type === "success"){
            return (
            <>
                {this.props.message && (
                    <div className="alert alert-success" style={{marginTop: "20px", display: "flex",}} >
                        <span className="glyphicon glyphicon-warning-sign" style={{fontSize: "18px"}}/>
                        <b style={{marginLeft: "17px"}}>{this.props.message}</b>
                    </div>
                )}
            </>
            );
        }

        // else return error notification
        return (
        <>
            {this.props.message && (
                <div className="alert alert-danger" style={{marginTop: "20px", display: "flex",}} >
                    <span className="glyphicon glyphicon-warning-sign" style={{fontSize: "18px"}}/>
                    <b style={{marginLeft: "17px"}}>{this.props.message}</b>
                </div>
            )}
        </>
        );
    }
}

export default NotificationPanel;